import { SegmentType } from '@ve-pro/enums/segment'
import { AssetType } from '@ve-pro/enums/asset'
import type {
  SegmentAudio,
  SegmentCollection,
  SegmentRateCollection,
} from '@ve-pro/types/track.type'
import { isSegmentDubbing } from './segment-subtitle'

// 元件的最小倍数
export const SEGMENT_RATE_MIN = 0.5
// 元件的最大倍数
export const SEGMENT_RATE_MAX = 16

/**
 * 配音 是否异常变速
 * 变速速率= 新配音时长/原始时长。当变速>2 变速<0.5时，作为异常变速。
 */
export function isAbnormalRate(
  dubbingSegment: SegmentAudio,
  specifyRateValue?: number,
): boolean {
  // 仅针对 配音
  if (!isSegmentDubbing(dubbingSegment)) {
    return false
  }

  const rate = specifyRateValue ?? dubbingSegment.rate
  return rate > 2 || rate < 0.5
}

/**
 * 获取元件最大的倍数
 * @param segment
 * @returns 倍数
 */
export function getSegmentRateMax(segment: SegmentCollection): number {
  const { duration } = segment.source_rate
  const value = Math.max(1, Math.ceil(duration / 10) / 10)
  return Math.min(value, SEGMENT_RATE_MAX)
}

/**
 * 设置元件的倍数为有效的倍数值
 * @param segment
 */
export function setSegmentValidRate(segment: SegmentCollection): void {
  segment.rate = Math.min(segment.rate, getSegmentRateMax(segment))
}

export function isSupportRate(
  segment: SegmentCollection,
): segment is SegmentRateCollection {
  return (
    segment.type === SegmentType.Audio ||
    (segment.type === SegmentType.Video &&
      segment.material.type === AssetType.Video)
  )
}

export function formatRateText(rate: number): string {
  return rate.toFixed(1) + 'x'
}
